import React, { useContext } from "react";
import VoucherServices, {
  AssetVoucherFilter,
  CashCreditFilter,
  ICostCentreModel,
  ITransactionLedgerDetail,
  RCMFilter,
  ReconcileTypes,
  Voucher_Type,
  VoucherFilterStatus,
  VoucherMode,
} from "../../Services/VoucherServices";
import {
  Button,
  Col,
  DatePicker,
  Popover,
  Row,
  Select,
  Skeleton,
  Space,
  Table,
  TableColumnsType,
  Tabs,
  Tooltip,
} from "antd";
import { Utils } from "../../../Utilities/Utils";
import { voucherType } from "../Reports/LedgerWiseVoucherDetails/VoucherDetailsByLedger";
import {
  DownloadOutlined,
  DeleteTwoTone,
  EditOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import CbRefereshIconButton from "../../Components/ui/IconButton/CbRefereshIconButton";
import { useClient } from "../../Context/ClientContext";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../Context/ThemeContext";
import { dayjs } from "../../../Utilities/dayjs";
import { notificationContext } from "../../Common/Routing/PageRoute";

import InvoiceExportService from "../../Services/InvoiceExportDetails";
import { SearchLedgerByGroupsTypes } from "../../Services/LedgerService";
import PayRecVoucherPDF from "../SalesAndPurchase/ReceiptAndPaymentOut/Pdf/PayRecVoucherPDF";
import ExpIncVocherPDF from "./ExpIncVocherPDF";
import { ConfirmationModal } from "../../Common/ConfirmationModal";
import CbTableRefereshIconButton from "../../Components/ui/IconButton/CbTableRefereshIconButton";
import VoucherDetailsByLedgerView from "../Reports/LedgerWiseVoucherDetails/VoucherDetailsByLedgerView";
type TargetKey = React.MouseEvent | React.KeyboardEvent | string;

interface ILedgerDetailsData {
  key: React.Key;
  sNo: number;
  ledgerId: string;
  date: string;
  number: string;
  ledgerName: string;
  voucherType: Voucher_Type;
  voucherStatus: VoucherFilterStatus;
  vId: string;
  totalVoucherAmount: number;
  ccTotal: number;
  isAssetVoucher: boolean;
  mode: VoucherMode;
}
const CostCentreTable = (props: {
  costCentreId: string;
  expenseId: string;
  expenseLedgerName: string;
}) => {
  const { currentClient, companySettings } = useClient();
  const { openNotification } = useContext(notificationContext);
  const width = window.innerWidth;
  const [loading, setLoading] = React.useState<boolean | undefined>(false);
  const [costCentresList, setCostCentresList] = React.useState<
    ILedgerDetailsData[]
  >([]);
  const [type, setType] = React?.useState<SearchLedgerByGroupsTypes>();
  const [openModel, setOpenModel] = React.useState<{
    type: string;
    param:
      | {
          id?: string;
          type?: VoucherFilterStatus | string;
          open?: boolean | undefined;
        }
      | string;
  }>({
    type: "",
    param: {
      id: "",
      type: VoucherFilterStatus.Active,
      open: false,
    },
  });
  const { RangePicker } = DatePicker;
  const [refreshButton, setRefreshButton] = React.useState<boolean>(false);
  const [confirmation, setConfirmation] = React.useState<boolean>(false);
  const [openModal, setOpenModal] = React.useState<{
    type?: Voucher_Type;
    voucherId?: string;
    open: boolean;
    name?: string;
  }>({ voucherId: "", open: false, name: "" });
  const [deleteVoucher, setDeleteVoucher] = React.useState<{
    id: string;
    isRev: boolean;
    number: string;
  }>({
    id: "",
    isRev: false,
    number: "",
  });
  const themeData: any = useTheme();
  const [filterDate, setFilterDate] = React.useState<{
    from: string;
    to: string;
  }>({
    from: dayjs(companySettings?.period?.from).format("DD/MM/YYYY"),
    to: dayjs(companySettings?.period?.to).format("DD/MM/YYYY"),
  });
  const [invoiceStatus, setInvoiceStatus] = React.useState<VoucherFilterStatus>(
    VoucherFilterStatus.Active
  );
  const [filter, setfilter] = React.useState<{
    sortCol: string;
    sortDir: string;
  }>({
    sortCol: "",
    sortDir: "",
  });
  const [exportType, setExportType] = React.useState<number>(-1);
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState<number>(0);
  const [exportData, setExportData] = React.useState<ILedgerDetailsData[]>([]);
  const navigate = useNavigate();
  const [moreTabs, setMoreTabs] = React.useState<any[]>([]);
  const [activeKey, setActiveKey] = React.useState<string>("");
  const [voucher, setVoucher] = React.useState<Voucher_Type>(Voucher_Type.All);

  // RemoveTabs
  const remove = (targetKey: TargetKey) => {
    const newPanes = moreTabs?.filter((pane) => pane.key !== targetKey);
    setMoreTabs(newPanes);
    if (newPanes.length && targetKey === activeKey) {
      setActiveKey(props.expenseId);
    }
  };
  React.useEffect(() => {
    if (currentClient?.id && props?.costCentreId) {
      getList(
        currentClient?.id,
        25, // expenses
        dayjs(filterDate.from, "DD/MM/YYYY").toISOString(),
        dayjs(filterDate.to, "DD/MM/YYYY").endOf("day").toISOString(),
        (page - 1) * pageSize,
        pageSize,
        filter.sortCol,
        filter.sortDir,
        "", // item id
        ReconcileTypes.Both,
        "", // search
        invoiceStatus,
        props?.costCentreId
      );
    }
  }, [
    currentClient?.id,
    page,
    pageSize,
    filter.sortCol,
    filter.sortDir,
    props.costCentreId,
    invoiceStatus,
    refreshButton,
    filterDate,
  ]);

  const getList = async (
    clientId: string,
    Voucher_Type: Voucher_Type,
    from: string,
    to: string,
    start: number,
    length: number,
    sortCol?: string,
    sortDir?: string,
    partyId?: string,
    IsReconcile?: ReconcileTypes,
    search?: string,
    status?: VoucherFilterStatus,
    costCentreId?: string
  ) => {
    try {
      if (exportType < 1) {
        setLoading(true);
      }
      const res = await VoucherServices.getVoucharList(
        clientId,
        Voucher_Type,
        from,
        to,
        start,
        length,
        sortCol,
        sortDir,
        partyId,
        IsReconcile,
        search,
        status,
        "",
        RCMFilter.Both,
        CashCreditFilter.All,
        null,
        AssetVoucherFilter.both,
        costCentreId
      );
      if (res?.result?.voucherItems?.length > 0) {
        let costCenList =
          res?.result?.voucherItems?.map((item: any, index: number) => {
            const dLedger =
              item?.dLedger
                ?.filter((dledger: ITransactionLedgerDetail) =>
                  dledger?.costCentresDetail?.find(
                    (cc: ICostCentreModel) => cc?.id === props?.costCentreId
                  )
                )
                .map((dledger: ITransactionLedgerDetail) => {
                  return {
                    costCentreTotal:
                      dledger?.costCentresDetail?.find(
                        (curr: ICostCentreModel) =>
                          curr?.id === props?.costCentreId
                      )?.value || 0,
                    ledgerName: dledger?.ledgerName,
                    ledgerId: dledger?.id,
                  };
                }) || [];
            return {
              key: index + 1,
              sNo: index + 1,
              vId: item?.vId,
              date: Utils.getFormattedDate(item.date),
              number: item?.number,
              totalVoucherAmount: item?.amountSummary?.totalInvoiceAmount,
              voucherType: item?.voucherType,
              voucherStatus: item?.voucherStatus,
              ledgerName: dLedger[0]?.ledgerName,
              ledgerId: dLedger[0]?.ledgerId,
              ccTotal: dLedger[0]?.costCentreTotal || 0,
              isAssetVoucher: item?.isAssetVoucher,
              mode: item.mode,
            };
          }) || [];

        setLoading(false);
        if (costCenList?.length > 0) {
          const exportWithoutDeleted = costCenList?.filter(
            (x: any) => x?.voucherStatus !== 1
          );
          setExportData(exportWithoutDeleted);
          setCostCentresList(costCenList);
        }
      } else {
        setCostCentresList([]);
        setLoading(false);
        if (res.message) {
          console.log("error", res.message);
          openNotification("error", res?.message);
        }
      }
    } catch (ex) {
      console.error("error..", ex);
      openNotification("error", ex);
      setLoading(false);
      setCostCentresList([]);
    }
  };

  React.useEffect(() => {
    if (deleteVoucher?.id) {
      const DeleteCreditNote = async () => {
        setLoading(true);
        await VoucherServices.deleteVoucher(
          currentClient?.id!,
          deleteVoucher.id
        ).then((res) => {
          setLoading(false);
          if (res?.result) {
            setRefreshButton(!refreshButton);
            openNotification(
              "success",
              `Voucher ${deleteVoucher.number} deleted successfully.`
            );
          }
        });
      };
      DeleteCreditNote();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteVoucher?.id]);

  const generateFooterRow = (columns: string[]) => {
    const costCentreTotal = costCentresList
      ?.filter((rcc: ILedgerDetailsData) => rcc?.voucherStatus !== 1)
      .reduce(
        (acc: number, rcc: ILedgerDetailsData) =>
          acc + (rcc?.ccTotal > 0 ? rcc?.ccTotal : 0),
        0
      );
    const VoucherTotal = costCentresList
      ?.filter((rcc: ILedgerDetailsData) => rcc?.voucherStatus !== 1)
      .reduce(
        (acc: number, rcc: ILedgerDetailsData) =>
          acc + (rcc?.totalVoucherAmount > 0 ? rcc?.totalVoucherAmount : 0),
        0
      );

    return columns.map((col) => {
      if (col === "Cost Centre Amount") {
        return `${Utils.getFormattedNumber(Math.abs(costCentreTotal))}`;
      } else if (col === "Voucher Amount") {
        return `${Utils.getFormattedNumber(Math.abs(VoucherTotal))}`;
      } else if (col === "Ref No.") {
        return "Total";
      } else {
        return "";
      }
    });
  };

  //console.log("Open Modal: ", openModal);

  const columnsA = [
    "S.No.",
    "Date",
    "Account Name",
    "Ref No.",
    "Voucher",
    "Cost Centre Amount",
    "Voucher Amount",
  ];
  const fieldMapping = {
    "S.No.": (item: ILedgerDetailsData) => item?.sNo,
    Date: (item: ILedgerDetailsData) => item?.date,
    "Account Name": (item: ILedgerDetailsData) => item?.ledgerName,
    "Ref No.": (item: ILedgerDetailsData) => item?.number,
    Voucher: (item: ILedgerDetailsData) => voucherType[item?.voucherType],
    "Cost Centre Amount": (item: ILedgerDetailsData) =>
      Utils.getFormattedNumber(item?.ccTotal > 0 ? item?.ccTotal : 0),
    "Voucher Amount": (item: ILedgerDetailsData) =>
      Utils.getFormattedNumber(
        item?.totalVoucherAmount > 0 ? item?.totalVoucherAmount : 0
      ),
  };

  let path = "Cost Centre Voucher List";
  const exportCsv = (exportData: ILedgerDetailsData[]) => {
    InvoiceExportService.generateCSV(
      exportData,
      columnsA,
      fieldMapping,
      generateFooterRow,
      filterDate,
      path,
      currentClient?.businessName
    );
    setExportType(0);
  };

  const exportPDF = (exportData: ILedgerDetailsData[]) => {
    InvoiceExportService.AutoDownloadPDF(
      exportData,
      currentClient?.businessName,
      columnsA,
      fieldMapping,
      generateFooterRow,
      filterDate,
      path,
      null
    );
    setExportType(0);
  };

  const exportExcel = async (exportData: ILedgerDetailsData[]) => {
    await InvoiceExportService.generateExcel(
      exportData,
      currentClient?.businessName,
      columnsA,
      fieldMapping,
      generateFooterRow,
      filterDate,
      path
    );
    setExportType(0);
  };

  const content = (
    <Space direction="vertical">
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="CSV"
          onClick={() => {
            if (exportData.length > 0) {
              exportCsv(exportData);
            } else {
              setExportType(1);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          CSV
        </Button>
      </div>

      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="PDF"
          onClick={() => {
            if (exportData.length > 0) {
              exportPDF(exportData);
            } else {
              setExportType(2);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          PDF
        </Button>
      </div>
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="XLSX"
          onClick={() => {
            if (exportData.length > 0) {
              exportExcel(exportData);
            } else {
              setExportType(3);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          XLSX
        </Button>
      </div>
    </Space>
  );

  const columns: TableColumnsType<ILedgerDetailsData> = [
    {
      title: "Date",
      key: "date",
      dataIndex: "date",
      sorter: true,
      ellipsis: true,
      width: "12%",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
          }}
          title={false}
        >
          {Utils.getFormattedDate(record?.date)}
        </Skeleton>
      ),
    },
    {
      title: "Account Name",
      key: "ledgerName",
      sorter: true,
      dataIndex: "ledgerName",
      width: "22%",
      align: "left",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          <div
            className={
              record.mode !== VoucherMode.Opening ? "cursorPointer" : ""
            }
            onClick={() =>
              record.mode !== VoucherMode.Opening && openNewTab(record)
            }
            style={{
              color:
                record.mode !== VoucherMode.Opening
                  ? themeData?.themeData?.themeColor
                  : "",
            }}
          >
            {record?.ledgerName}
          </div>
        </Skeleton>
      ),
    },
    {
      title: "Ref.No",
      key: "number",
      sorter: true,
      dataIndex: "number",
      ellipsis: true,
      width: "12%",
      align: "left",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.voucherStatus === 1 ? (
            <>
              <span style={{ color: "red" }}>{record?.number}</span>
            </>
          ) : (
            <>
              <span
                style={{
                  color: themeData?.themeData?.themeColor,
                  cursor: "pointer",
                }}
                onClick={() =>
                  setOpenModal({
                    voucherId: record?.vId,
                    open: true,
                    type: record?.voucherType,
                    name:
                      record?.voucherType === Voucher_Type.Expenses ||
                      record?.voucherType === Voucher_Type.Income
                        ? "expIncModalOpen"
                        : record?.voucherType === Voucher_Type.Payment ||
                          record?.voucherType === Voucher_Type.Receipt
                        ? "payRecModalOpen"
                        : "",
                  })
                }
              >
                {<Tooltip title={record?.number}>{record?.number}</Tooltip>}
              </span>
            </>
          )}
        </Skeleton>
      ),
    },
    {
      title: "Voucher",
      key: "voucherType",
      dataIndex: "voucherType",
      ellipsis: true,
      width: "11%",
      // width: width <= 1440 ? "10%" : "9%",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
          }}
          title={false}
        >
          {voucherType[record?.voucherType]}
        </Skeleton>
      ),
    },
    {
      title: "Cost Centre Amount",
      key: "ccTotal",
      dataIndex: "ccTotal",
      ellipsis: true,
      width: "14%",
      align: "right",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {record.voucherStatus !== 1 ? (
            <>
              {Utils.getFormattedNumber(
                record?.ccTotal > 0 ? record?.ccTotal : 0
              )}
            </>
          ) : (
            <>
              <span style={{ textDecoration: "line-through" }}>
                {Utils.getFormattedNumber(
                  record?.ccTotal > 0 ? record?.ccTotal : 0
                )}
              </span>
            </>
          )}
        </Skeleton>
      ),
    },
    {
      title: "Voucher Amount",
      key: "totalVoucherAmount",
      dataIndex: "totalVoucherAmount",
      ellipsis: true,
      width: "12%",
      align: "right",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {record.voucherStatus !== 1 ? (
            <>
              {Utils.getFormattedNumber(
                record?.totalVoucherAmount > 0 ? record?.totalVoucherAmount : 0
              )}
            </>
          ) : (
            <>
              <span style={{ textDecoration: "line-through" }}>
                {Utils.getFormattedNumber(
                  record?.totalVoucherAmount > 0
                    ? record?.totalVoucherAmount
                    : 0
                )}
              </span>
            </>
          )}
        </Skeleton>
      ),
    },
    {
      title: "Action",
      key: "id",
      dataIndex: "icon2",
      width: "7%",
      align: "center",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.voucherStatus !== 1 ? (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Tooltip title="Edit" color="#444653" placement="top">
                <EditOutlined
                  twoToneColor="#444653"
                  style={{ marginRight: "10px" }}
                  onClick={() => {
                    invoiceStatus === VoucherFilterStatus.Draft
                      ? //Drafts Section
                        record?.isAssetVoucher === true &&
                        record?.voucherType === Voucher_Type?.PurchaseVoucher
                        ? navigate(
                            `/books/clients/${currentClient?.id}/asset/editFixedAssetDraft/${record?.vId}`
                          )
                        : record?.voucherType === Voucher_Type.Income
                        ? navigate(
                            `/books/clients/${currentClient?.id}/income/editIncomeDraft/${record?.vId}`
                          )
                        : record?.voucherType === Voucher_Type.Expenses
                        ? navigate(
                            `/books/clients/${currentClient?.id}/expenses/editExpensesDraft/${record?.vId}`
                          )
                        : record?.voucherType === Voucher_Type.Receipt
                        ? navigate(
                            `/books/clients/${currentClient?.id}/sales/editReceiptDraft/${record?.vId}`
                          )
                        : record?.voucherType === Voucher_Type.Payment
                        ? navigate(
                            `/books/clients/${currentClient?.id}/purchase/editPaymentOutDraft/${record?.vId}`
                          )
                        : record?.voucherType === Voucher_Type.SalesVoucher
                        ? navigate(
                            `/books/clients/${currentClient?.id}/sales/editInvoiceDraft/${record?.vId}`,
                            {
                              state: { copy: false },
                            }
                          )
                        : record?.voucherType === Voucher_Type?.PurchaseVoucher
                        ? navigate(
                            `/books/clients/${currentClient?.id}/purchase/editBillDraft/${record?.vId}`,
                            {
                              state: { copy: false },
                            }
                          )
                        : record?.voucherType === Voucher_Type.CreditNote
                        ? navigate(
                            `/books/clients/${currentClient?.id}/sales/editCreditNoteDraft/${record?.vId}`
                          )
                        : record?.voucherType === Voucher_Type.DebitNote
                        ? navigate(
                            `/books/clients/${currentClient?.id}/sales/editCreditNoteDraft/${record?.vId}`
                          )
                        : record?.voucherType === Voucher_Type.Journal
                        ? navigate(
                            `/books/clients/${currentClient?.id}/journals/${record?.vId}`
                          )
                        : record?.voucherType === Voucher_Type.Quotation
                        ? navigate(
                            `/books/clients/${currentClient?.id}/sales/editEstimateDraft/${record?.vId}`
                          )
                        : record?.voucherType === Voucher_Type.SalesOrder
                        ? navigate(
                            `/books/clients/${currentClient?.id}/sales/editSalesOrderDraft/${record?.vId}`
                          )
                        : record?.voucherType === Voucher_Type.PurchaseOrder
                        ? navigate(
                            `/books/clients/${currentClient?.id}/purchase/editPurchaseOrderDraft/${record?.vId}`
                          )
                        : setOpenModal({ voucherId: record?.vId, open: false })
                      : // Vouchers Section
                      record?.voucherType === Voucher_Type.Income
                      ? navigate(
                          `/books/clients/${currentClient?.id}/income/editIncome/${record?.vId}`
                        )
                      : record?.voucherType === Voucher_Type.Expenses
                      ? navigate(
                          `/books/clients/${currentClient?.id}/expenses/editExpenses/${record?.vId}`
                        )
                      : record?.voucherType === Voucher_Type.Receipt
                      ? navigate(
                          `/books/clients/${currentClient?.id}/sales/editReceipt/${record?.vId}`
                        )
                      : record?.voucherType === Voucher_Type.Payment
                      ? navigate(
                          `/books/clients/${currentClient?.id}/purchase/editPaymentOut/${record?.vId}`
                        )
                      : record?.voucherType === Voucher_Type.SalesVoucher
                      ? navigate(
                          `/books/clients/${currentClient?.id}/sales/editInvoice/${record?.vId}`,
                          {
                            state: { copy: false },
                          }
                        )
                      : record?.isAssetVoucher === true &&
                        record?.voucherType === Voucher_Type?.PurchaseVoucher
                      ? navigate(
                          `/books/clients/${currentClient?.id}/asset/editFixedAsset/${record?.vId}`
                        )
                      : record?.voucherType === Voucher_Type?.PurchaseVoucher
                      ? navigate(
                          `/books/clients/${currentClient?.id}/purchase/editPurchaseBill/${record?.vId}`,
                          {
                            state: { copy: false },
                          }
                        )
                      : record?.voucherType === Voucher_Type.CreditNote
                      ? navigate(
                          `/books/clients/${currentClient?.id}/sales/editCreditNote/${record?.vId}`
                        )
                      : record?.voucherType === Voucher_Type.DebitNote
                      ? navigate(
                          `/books/clients/${currentClient?.id}/sales/editCreditNote/${record?.vId}`
                        )
                      : record?.voucherType === Voucher_Type.Journal
                      ? navigate(
                          `/books/clients/${currentClient?.id}/journals/${record?.vId}`
                        )
                      : setOpenModal({ voucherId: record?.vId, open: false });

                    setType(SearchLedgerByGroupsTypes?.All);

                    if (invoiceStatus === VoucherFilterStatus.Draft) {
                      setOpenModel({
                        type: "adjustBankBalance",
                        param: {
                          id: "",
                          type: VoucherFilterStatus.Draft,
                        },
                      });
                    } else {
                      setOpenModel({
                        type: "adjustBankBalance",
                        param: {
                          id: "",
                          type: "",
                        },
                      });
                    }

                    // Navigate
                    // setId(record?.id);
                    // setType(SearchLedgerByGroupsTypes?.All);
                    // setOpenModel({
                    //   type: "adjustBankBalance",
                    //   param: {
                    //     id: "",
                    //     type: "",
                    //   },
                    // });
                  }}
                />
              </Tooltip>
              {invoiceStatus !== VoucherFilterStatus.Deleted && (
                <Tooltip title="Delete" color="red" placement="top">
                  <DeleteTwoTone
                    className="ca-delete-btn cursor"
                    twoToneColor="#ff879d"
                    onClick={() => {
                      setConfirmation(true);
                      setOpenModal({ voucherId: record?.vId, open: false });
                      setDeleteVoucher({
                        ...deleteVoucher,
                        number: record?.number,
                      });
                    }}
                  />
                </Tooltip>
              )}
            </div>
          ) : (
            <>
              {/* <Tag color="red">Deleted</Tag> */}
              <Tooltip title="Revive Voucher">
                <SyncOutlined
                  style={{ color: "green" }}
                  onClick={() => {
                    record?.isAssetVoucher === true &&
                    record?.voucherType === Voucher_Type?.PurchaseVoucher
                      ? navigate(
                          `/books/clients/${currentClient?.id}/asset/editFixedAssetDraft/${record?.vId}`
                        )
                      : record?.voucherType === Voucher_Type.Receipt
                      ? navigate(
                          `/books/clients/${currentClient?.id}/sales/editReceipt/${record?.vId}`
                        )
                      : record?.voucherType === Voucher_Type.Payment
                      ? navigate(
                          `/books/clients/${currentClient?.id}/purchase/editPaymentOut/${record?.vId}`
                        )
                      : record?.voucherType === Voucher_Type.SalesVoucher
                      ? navigate(
                          `/books/clients/${currentClient?.id}/sales/editInvoice/${record?.vId}`,
                          {
                            state: { copy: false },
                          }
                        )
                      : record?.voucherType === Voucher_Type?.PurchaseVoucher
                      ? navigate(
                          `/books/clients/${currentClient?.id}/sales/editInvoice/${record?.vId}`,
                          {
                            state: { copy: false },
                          }
                        )
                      : record?.voucherType === Voucher_Type.CreditNote
                      ? navigate(
                          `/books/clients/${currentClient?.id}/sales/editCreditNote/${record?.vId}`
                        )
                      : record?.voucherType === Voucher_Type.DebitNote
                      ? navigate(
                          `/books/clients/${currentClient?.id}/sales/editCreditNote/${record?.vId}`
                        )
                      : record?.voucherType === Voucher_Type.Journal
                      ? navigate(
                          `/books/clients/${currentClient?.id}/journals/${record?.vId}`
                        )
                      : record?.voucherType === Voucher_Type.Income
                      ? navigate(
                          `/books/clients/${currentClient?.id}/income/editIncome/${record?.vId}`
                        )
                      : record?.voucherType === Voucher_Type.Expenses
                      ? navigate(
                          `/books/clients/${currentClient?.id}/expenses/editExpenses/${record?.vId}`
                        )
                      : setOpenModal({ voucherId: record?.vId, open: false });
                    setType(SearchLedgerByGroupsTypes?.All);
                  }}
                />
              </Tooltip>
            </>
          )}
        </Skeleton>
      ),
    },
  ];

  const getQuarterPreset: any = (startMonth: number) => {
    const fromDate = dayjs(companySettings?.period?.from);
    return [
      fromDate.month(fromDate.month() + startMonth).startOf("month"),
      fromDate.month(fromDate.month() + startMonth + 2).endOf("month"),
    ];
  };

  const thisYear = () => {
    const fromDate = dayjs(companySettings?.period?.from);
    return [
      fromDate.month(fromDate.month()).startOf("month"),
      fromDate.month(fromDate.month() + 11).endOf("month"),
    ];
  };

  const lastYear = () => {
    const fromDate = dayjs(companySettings?.period?.from);
    return [
      fromDate.month(fromDate.month() - 12).startOf("month"),
      fromDate.month(fromDate.month() - 1).endOf("month"),
    ];
  };

  const getLast15Days = () => {
    const now = dayjs(); // Get the current date
    const startDate = now.subtract(15, "day").startOf("day"); // Start 15 days ago from today
    const endDate = now.endOf("day"); // End of the current day
    return [startDate, endDate];
  };
  const getLast7Days = () => {
    const now = dayjs(); // Get the current date
    const startDate = now.subtract(7, "day").startOf("day"); // Start 7 days ago from today
    const endDate = now.endOf("day"); // End of the current day
    return [startDate, endDate];
  };

  const getThisMonth = () => {
    const now = dayjs();
    return [now.startOf("month"), now.endOf("month")];
  };
  const getLastMonth = () => {
    const now = dayjs();
    const lastMonth = now.subtract(1, "month");
    return [lastMonth.startOf("month"), lastMonth.endOf("month")];
  };

  const tableSort = (pagination?: any, sort?: any, filter?: any) => {
    setfilter({
      sortCol: filter.column !== undefined ? filter.columnKey : "AutoNumber",
      sortDir:
        filter.column !== undefined
          ? filter.order === "descend"
            ? "desc"
            : "asc"
          : "desc",
    });
  };

  const commonBar = () => (
    <Row justify="space-between">
      <Col>
        <Space size={width <= 768 ? 440 : 5}>
          <RangePicker
            disabledDate={(current) =>
              current < dayjs("1900-01-01", "YYYY-MM-DD").add(-1, "day")
            }
            allowClear={false}
            format="DD-MM-YYYY"
            style={{ width: "250px" }}
            defaultValue={[
              dayjs(filterDate?.from, "DD/MM/YYYY"),
              dayjs(filterDate?.to, "DD/MM/YYYY"),
            ]}
            onChange={(e: any) => {
              if (e === null) {
                setFilterDate({ from: "", to: "" });
              } else {
                setFilterDate({
                  ...filterDate,
                  from: dayjs(e[0]).format("DD/MM/YYYY"),
                  to: dayjs(e[1]).format("DD/MM/YYYY"),
                });
                localStorage.setItem(
                  "LockPeriod",
                  JSON.stringify({
                    ...filterDate,
                    from: dayjs(e[0]).format("DD/MM/YYYY"),
                    to: dayjs(e[1]).format("DD/MM/YYYY"),
                  })
                );
              }
              openNotification("success", `Period locked.`);
              moreTabs.length > 0 && setMoreTabs([]);
            }}
            presets={[
              {
                label: "Today",
                value: [dayjs().add(0, "d"), dayjs()],
              },
              {
                label: "Last 7 Days",
                value: getLast7Days(),
              },
              {
                label: "Last 15 Days",
                value: getLast15Days(),
              },
              {
                label: "This Month",
                value: getThisMonth(),
              },
              {
                label: "Last Month",
                value: getLastMonth(),
              },
              {
                label: "Quarter 1",
                value: getQuarterPreset(0),
              },
              {
                label: "Quarter 2",
                value: getQuarterPreset(3),
              },
              {
                label: "Quarter 3",
                value: getQuarterPreset(6),
              },
              {
                label: "Quarter 4",
                value: getQuarterPreset(9),
              },
              {
                label: "This Year",
                value: thisYear(),
              },
              {
                label: "Last Year",
                value: lastYear(),
              },
            ]}
          />

          {moreTabs.length > 0 && activeKey != null && activeKey != "" && (
            <>
              <Select
                clearIcon={true}
                value={voucher}
                style={{ width: "150px" }}
                allowClear={false}
                options={[
                  { value: Voucher_Type.All, label: "All Vouchers" },
                  {
                    value: Voucher_Type.SalesVoucher,
                    label: "Sales Invoice",
                  },
                  { value: Voucher_Type.CreditNote, label: "Credit Note" },
                  {
                    value: Voucher_Type.PurchaseVoucher,
                    label: "Purchase Invoice",
                  },
                  { value: Voucher_Type.DebitNote, label: "Debit Note" },
                  { value: Voucher_Type.Expenses, label: "Expenses" },
                  { value: Voucher_Type.Income, label: "Incomes" },
                  { value: Voucher_Type.Receipt, label: "Receipt" },
                  { value: Voucher_Type.Payment, label: "Payment" },
                  { value: Voucher_Type.Journal, label: "Journal" },
                  { value: Voucher_Type.Contra, label: "Contra" },
                ]}
                onChange={(val: Voucher_Type) => {
                  setPage(1);
                  setVoucher(val);
                  setMoreTabs([]);
                }}
              />
            </>
          )}
        </Space>
      </Col>

      <Col
        style={{
          marginTop: width <= 768 ? 15 : "",
        }}
      >
        <Row gutter={width <= 768 ? 60 : 8}>
          <Col>
            <Space size={width <= 768 ? 440 : 5}>
              <CbTableRefereshIconButton
                disabled={loading}
                onClick={() => setRefreshButton(!refreshButton)}
              />

              {costCentresList?.length === 0 ||
              invoiceStatus === VoucherFilterStatus.Deleted ||
              costCentresList?.filter(
                (x: ILedgerDetailsData) => x?.voucherStatus === 1
              )?.length === costCentresList?.length ? (
                <>
                  <Button type="default" icon={<DownloadOutlined />} disabled />
                </>
              ) : (
                <>
                  <Popover
                    content={content}
                    placement="rightTop"
                    trigger="hover"
                  >
                    <Button type="default" icon={<DownloadOutlined />} />
                  </Popover>
                </>
              )}
              <Select
                value={invoiceStatus}
                style={{ width: 120 }}
                allowClear={false}
                options={[
                  {
                    value: VoucherFilterStatus.All,
                    label: <span title={""}>All</span>,
                  },
                  {
                    value: VoucherFilterStatus.Active,
                    label: <span title={""}>Active</span>,
                  },
                  {
                    value: VoucherFilterStatus.Deleted,
                    label: <span title={""}>Deleted</span>,
                  },
                  {
                    value: VoucherFilterStatus.Draft,
                    label: <span title={""}>Draft</span>,
                  },
                ]}
                onChange={(val: VoucherFilterStatus) => {
                  //  setPage(1);
                  setInvoiceStatus(val);
                }}
              />
            </Space>
          </Col>
        </Row>
      </Col>
    </Row>
  );

  const openNewTab = (record: any) => {
    const newActiveKey = record?.ledgerId;
    if (moreTabs.find((x: any) => x.key === newActiveKey)) {
      setActiveKey(newActiveKey);
    } else {
      setMoreTabs([
        ...moreTabs,
        {
          label: `${record?.ledgerName}`,
          children: "New Tab Pane",
          key: newActiveKey,
        },
      ]);
      setActiveKey(newActiveKey);
    }
  };
  console.log("activeKey", activeKey, "moretabs", moreTabs);

  const openRowStyle = (record: any, index: number | undefined) => {
    // Return an object with the desired CSS style for the row
    return {
      background: record.mode === VoucherMode.Opening ? "#f2f5f3" : "none",
    };
  };

  const initialItems = [
    {
      label: props.expenseLedgerName,
      key: props.expenseId,
      closable: false,
      children: (
        <div style={{ padding: "4px" }}>
          {commonBar()}
          <Table
            className={`Tabel-style table-${
              themeData?.themeData?.componentSize ?? "middle"
            }`}
            size="small"
            columns={columns}
            onRow={(record, index) => ({
              style: openRowStyle(record, index),
            })}
            locale={{
              triggerDesc: "",
              triggerAsc: "",
              cancelSort: "",
            }}
            dataSource={
              loading
                ? (Array.from({ length: 15 }, (_, index) => ({
                    key: `loading-${index}`,
                  })) as ILedgerDetailsData[])
                : costCentresList
            }
            pagination={false}
            scroll={
              costCentresList.length > 15 ? { x: 800, y: 720 } : { x: 700 }
            }
            onChange={tableSort}
            summary={() => {
              return (
                <Table.Summary fixed>
                  <Table.Summary.Row
                    style={{
                      backgroundColor: "#f5f8ff",
                      fontWeight: "bold",
                      color: "#4d4d4d",
                    }}
                  >
                    <Table.Summary.Cell
                      index={1}
                      className="fw600"
                    ></Table.Summary.Cell>
                    <Table.Summary.Cell
                      index={2}
                      className="fw600"
                    ></Table.Summary.Cell>
                    <Table.Summary.Cell index={3} className="fw600">
                      Total
                    </Table.Summary.Cell>
                    <Table.Summary.Cell
                      index={4}
                      className="fw600"
                    ></Table.Summary.Cell>
                    <Table.Summary.Cell
                      index={5}
                      align="right"
                      className="fw600"
                    >
                      {/* ₹{" "} */}
                      {Utils.getFormattedNumber(
                        Math?.abs(
                          costCentresList
                            ?.filter(
                              (rcc: ILedgerDetailsData) =>
                                rcc?.voucherStatus !== 1
                            )
                            .reduce(
                              (acc: number, rcc: ILedgerDetailsData) =>
                                acc + (rcc?.ccTotal > 0 ? rcc?.ccTotal : 0),
                              0
                            )
                        )
                      )}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell
                      index={5}
                      className="fw600"
                      align="right"
                    >
                      {/* ₹{" "} */}
                      {Utils.getFormattedNumber(
                        Math?.abs(
                          costCentresList
                            ?.filter(
                              (rcc: ILedgerDetailsData) =>
                                rcc?.voucherStatus !== 1
                            )
                            .reduce(
                              (acc: number, rcc: ILedgerDetailsData) =>
                                acc +
                                (rcc?.totalVoucherAmount > 0
                                  ? rcc?.totalVoucherAmount
                                  : 0),
                              0
                            )
                        )
                      )}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={7}></Table.Summary.Cell>
                  </Table.Summary.Row>
                </Table.Summary>
              );
            }}
          />
        </div>
      ),
    },
  ];
  // console.log("initialItems", initialItems, moreTabs);

  const updatedItems = initialItems?.concat(
    moreTabs?.map((tab: any) => ({
      label: tab.label,
      key: tab.key,
      closable: true,
      children: (
        <div style={{ width: "100%" }} className="m-auto">
          {/* {commonBar()} */}
          <VoucherDetailsByLedgerView
            ledgerId={tab.key}
            refresh={false}
            filterFromDate={filterDate?.from}
            filterToDate={filterDate?.to}
            partyOrTax={""}
            setActiveKey={setActiveKey}
            setMoreTabs={setMoreTabs}
            moreTabs={moreTabs}
            firstLedgerId={props?.expenseId}
            voucherType={voucher}
            // setFilterDate={(x: any) => setFilterDate(x)}
          />
        </div>
      ),
    }))
  );
  return (
    <div>
      {moreTabs?.length > 0 ? (
        <Tabs
          hideAdd
          type="editable-card"
          // className="tabFlexOverride"
          onEdit={remove}
          activeKey={activeKey}
          items={updatedItems}
          onChange={(key) => setActiveKey(key)}
          tabBarExtraContent={
            <Button
              className="ms-10"
              onClick={() => {
                setMoreTabs([]);
                //setTabData(undefined);
                setActiveKey("");
              }}
            >
              Close All
            </Button>
          }
        />
      ) : (
        <>
          <div style={{ padding: "4px" }}>
            {/* <VoucherDetailsByLedgerView
            ledgerId={props.ledgerId}
            refresh={props?.refresh}
            filterFromDate={props?.filterFromDate}
            filterToDate={props?.filterToDate}
            partyOrTax={props?.filterToDate}
            setActiveKey={setActiveKey}
            setMoreTabs={setMoreTabs}
            moreTabs={moreTabs}
            firstLedgerId={props?.ledgerId}
            voucherType={voucher}
          /> */}
            {commonBar()}
            <Table
              className={`Tabel-style table-${
                themeData?.themeData?.componentSize ?? "middle"
              }`}
              size="small"
              columns={columns}
              // onRow={(record, index) => ({
              //   style: openRowStyle(record, index),
              // })}
              locale={{
                triggerDesc: "",
                triggerAsc: "",
                cancelSort: "",
              }}
              dataSource={
                loading
                  ? (Array.from({ length: 15 }, (_, index) => ({
                      key: `loading-${index}`,
                    })) as ILedgerDetailsData[])
                  : costCentresList
              }
              pagination={false}
              scroll={
                costCentresList.length > 15 ? { x: 800, y: 720 } : { x: 700 }
              }
              onChange={tableSort}
              summary={() => {
                return (
                  <Table.Summary fixed>
                    <Table.Summary.Row
                      style={{
                        backgroundColor: "#f5f8ff",
                        fontWeight: "bold",
                        color: "#4d4d4d",
                      }}
                    >
                      <Table.Summary.Cell
                        index={1}
                        className="fw600"
                      ></Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={2}
                        className="fw600"
                      ></Table.Summary.Cell>
                      <Table.Summary.Cell index={3} className="fw600">
                        Total
                      </Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={4}
                        className="fw600"
                      ></Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={5}
                        align="right"
                        className="fw600"
                      >
                        {/* ₹{" "} */}
                        {Utils.getFormattedNumber(
                          Math?.abs(
                            costCentresList
                              ?.filter(
                                (rcc: ILedgerDetailsData) =>
                                  rcc?.voucherStatus !== 1
                              )
                              .reduce(
                                (acc: number, rcc: ILedgerDetailsData) =>
                                  acc + (rcc?.ccTotal > 0 ? rcc?.ccTotal : 0),
                                0
                              )
                          )
                        )}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell
                        index={5}
                        className="fw600"
                        align="right"
                      >
                        {/* ₹{" "} */}
                        {Utils.getFormattedNumber(
                          Math?.abs(
                            costCentresList
                              ?.filter(
                                (rcc: ILedgerDetailsData) =>
                                  rcc?.voucherStatus !== 1
                              )
                              .reduce(
                                (acc: number, rcc: ILedgerDetailsData) =>
                                  acc +
                                  (rcc?.totalVoucherAmount > 0
                                    ? rcc?.totalVoucherAmount
                                    : 0),
                                0
                              )
                          )
                        )}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={7}></Table.Summary.Cell>
                    </Table.Summary.Row>
                  </Table.Summary>
                );
              }}
            />
          </div>
        </>
      )}

      {openModal.name === "payRecModalOpen" && (
        <PayRecVoucherPDF
          open={openModal.open}
          onCancel={() => setOpenModal({ open: false })}
          voucherId={openModal.voucherId}
          type={openModal.type}
        />
      )}

      {openModal.name === "expIncModalOpen" && (
        <ExpIncVocherPDF
          open={openModal.open}
          onCancel={() => setOpenModal({ open: false })}
          voucherId={openModal.voucherId}
          type={openModal.type}
        />
      )}

      {confirmation && (
        <ConfirmationModal
          open={confirmation}
          onNo={() => setConfirmation(false)}
          onYes={() => {
            setDeleteVoucher({
              ...deleteVoucher,
              id: openModal?.voucherId!,
              isRev:
                invoiceStatus === VoucherFilterStatus.Deleted ? true : false,
            });
            setConfirmation(false);
          }}
          text={
            invoiceStatus === VoucherFilterStatus.Deleted
              ? `Are you sure you want to revive "${deleteVoucher.number}" ?`
              : `Are you sure you want to deleteVoucher "${deleteVoucher.number}" ?`
          }
        />
      )}
    </div>
  );
};

export default CostCentreTable;
